import React, { useContext, useMemo, useState } from 'react';

import PageLoader from '../components/common/PageLoader';
import StickyPageHeader from '../components/common/StickyPageHeader';
import CarrierNotesPanel from '../components/panels/CarrierNotesPanel';
import { AuthContext } from '../contexts/authContext';
import {
  useCarrierNotes,
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierNotesPage = ({ disableLayout, routes }) => {
  const { authUser } = useContext(AuthContext);
  const { carrierId, selectedCarrier } = useSelectedCarrier();
  const { carrierNotes, status } = useCarrierNotes(carrierId);
  const userHasPermission = useUserPermission();
  const [headerActions, setHeaderActions] = useState(null);

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const canView =
    !!selectedCarrier &&
    userHasPermission(selectedCarrier, 'notesPermission');

  const carrierWithNotes = useMemo(
    () =>
      selectedCarrier
        ? { ...selectedCarrier, notes: carrierNotes ?? selectedCarrier.notes }
        : selectedCarrier,
    [selectedCarrier, carrierNotes]
  );

  const pageDataLoading = status === 'loading';

  const content =
    canView && (
      <>
        <StickyPageHeader
          actions={headerActions}
          subtitle={selectedCarrier.name}
          title="Notes"
        />
        <CarrierNotesPanel
          carrier={carrierWithNotes}
          id="notes"
          onHeaderActions={setHeaderActions}
        />
      </>
    );

  if (disableLayout) {
    return pageDataLoading ? <PageLoader /> : (content || null);
  }

  return (
    <Layout
      carrierLoading={!selectedCarrier || pageDataLoading}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {content}
    </Layout>
  );
};

export default CarrierNotesPage;
